import { NgModule } from '@angular/core';
import { BciAccordionModule, BciFormMsgModule, BciSpinnerModule, BciWkButtonModule, BciWkInputTextModule, BciWkModalModule, BciWkStepperHorizontalModule, BciWkTypographyModule } from '@bci/webkitbci';
import { LoadingComponent } from './components/loading/loading.component';

@NgModule({
  declarations: [LoadingComponent],
  imports: [
    BciWkInputTextModule,
    BciFormMsgModule,
    BciWkTypographyModule,
    BciWkButtonModule,
    BciAccordionModule,
    BciWkStepperHorizontalModule,
    BciWkModalModule,
    BciSpinnerModule,
  ],
  exports: [
    BciWkInputTextModule,
    BciFormMsgModule,
    BciWkTypographyModule,
    BciWkButtonModule,
    BciAccordionModule,
    BciWkStepperHorizontalModule,
    BciWkModalModule,
    BciSpinnerModule,
    LoadingComponent,
  ],
})
export class SharedModule {}
